<!-- eslint-disable vue/no-v-html -->
<template>
  <aside ref="sidebar" class="OSidebar" level="0">
    <!-- @mouseenter="debounce(50, handleMouseEnter, 'sideTime')()" -->
    <!-- @mouseleave="debounce(10, handleMouseLeave, 'sideTime')()" -->

    <HeaderMenuBase
      v-if="showHeader"
      :close-menu
      :menu
      :loading
      @click:btn-side="toggleSideMenu"
    />

    <q-list class="Nv0-ul flex flex-col h-full !my-[5rem]" tag="ul">
      <!-- :to="Nv0.userId ? `${Nv0.href}/${Nv0.userId}` : Nv0.href" -->
      <!-- :tag="pathTo(Nv0)?.href ? 'a' : 'li'" -->
      <MenuLi
        v-for="(Nv0, index) in menuAfterPermission"
        :key="Nv0.title + index"
        :data="Nv0"
        :sidebar="sidebar"
        :tag="Nv0.href ? 'a' : 'li'"
        :href="Nv0.href"
        :show-header="showHeader"
        :exact="true"
        class="text-white"
        @Nv0Click="() => handleClick(true)"
        @click="(e) => Nv0HandleClick(e, Nv0)"
        @click:close="onSubmenuClickClose"
      >
        <q-item-section v-if="Nv0.icon" avatar class="min-w-32 pl-10">
          <q-icon
            class="size-24"
            :class="state.hover ? 'opacity-70' : 'opacity-60'"
            :name="Nv0.icon"
          />

          <!-- <div
            v-if="Nv0.icon"
            class="text-2xl w-32 h-32 icon-container grid place-items-center"
            v-html="Nv0.icon"
          /> -->
        </q-item-section>

        <q-item-section class="Nv0-text text-headline-2">
          <p class="one-line text-headline-2">
            {{ Nv0.title }}
          </p>
        </q-item-section>

        <q-item-section v-if="Nv0.submenu" avatar>
          <q-icon
            class="text-primary-pure"
            size="1.5rem"
            name="navigate_next"
          />
        </q-item-section>

        <q-tooltip v-if="!state?.hover" v-bind="tooltipPropsSidebar">
          {{ Nv0.title }}
        </q-tooltip>
      </MenuLi>

      <q-item
        v-for="item in menu.botao_menu_lateral"
        :key="item.id"
        clickable
        class="Nv0-li text-white"
        @click="
          () => {
            closeMenu()
            $emit('click:botao-generico', item)
          }
        "
      >
        <q-item-section avatar class="min-w-32 pl-10">
          <q-icon
            class="size-24"
            :class="state.hover ? 'opacity-70' : 'opacity-60'"
            :name="item.icone"
          />
        </q-item-section>

        <q-item-section class="Nv0-text text-headline-2">
          <p class="one-line">
            {{ item.titulo }}
          </p>
        </q-item-section>

        <q-tooltip v-if="!state?.hover" v-bind="tooltipPropsSidebar">
          {{ item.titulo }}
        </q-tooltip>
      </q-item>

      <MenuRespostas
        :close-menu
        :state
        :menu
        :loading
        @click:questionario="handleMouseEnter"
      />
    </q-list>
    <MenuLogo />
  </aside>
  <!-- <Teleport to="body">
    <span
      v-if="state.open"
      class="OSidebar-deep"
      @click="() => handleClick(false)"
    />
  </Teleport> -->
</template>

<script setup>
import { closeMenu, state } from './MenuState'
import {
  computed,
  onMounted,
  onUnmounted,
  provide,
  ref,
  watch,
} from 'vue'
import { debounce, tooltipPropsSidebar } from 'js/utils/GLOBAL'
import { Screen } from 'quasar'
import { useRoute } from 'vue-router'
import HeaderMenuBase from 'components/Header/HeaderMenuBase.vue'
import MenuLi from './MenuLi.vue'
import MenuLogo from './MenuLogo.vue'
import MenuRespostas from './MenuRespostas.vue'
import useMenu from 'composables/useMenu'

const route = useRoute()

const props = defineProps({
  menuList: {
    type: Array,
    default: () => [],
  },
})

const { menu, loading } = useMenu()

const menuAfterPermission = computed(() => {
  return props.menuList.filter((i) => {
    if (!i.show) return false
    else return i
  })
  // return []
})

const pathTo = (i) => {
  const params = i?.params || {}
  const opts = i?.opts || {}

  return {
    ...i,
    ...params,
    ...opts,
  }
}

const showHeader = ref(true)

const sidebar = ref(null)

let $ = {}

onMounted(() => {
  $ = {
    Nv0: sidebar.value,
    body: document.body,
  }
  setTimeout(() => {
    state.value.passive = false
  }, 300)
})

watch(showHeader, () => {
  if (!showHeader.value) {
    $.body.classList.add('showHeader')
  } else {
    $.body.classList.remove('showHeader')
  }
})

watch(
  () => state.value.open,
  (open) => {
    if (open) {
      $.body.classList.add('sidebar-open')
    } else {
      $.body.classList.remove('sidebar-open')
      state.value.hover = false
      toggleActiveOnLis()
    }
  }
)

watch(
  () => state.value.hover,
  (hover) => {
    if (hover) {
      !Screen.lt.md && $.body.classList.add('sidebar-active')
    } else {
      $.body.classList.remove('sidebar-active')
    }
  }
)

// onBeforeRouteLeave(() => {
//   state.value = {
//     hover: false,
//     open: false,
//     passive: true,
//   };
// });

// onBeforeRouteUpdate(() => {
//   state.value = {
//     hover: false,
//     open: false,
//   };
// });

function toggleSideMenu() {
  if (state.value.hover) {
    handleMouseLeave()
  } else {
    handleMouseEnter()
  }
}

function handleMouseEnter() {
  if (state.value.passive) return
  state.value.hover = true
  state.value.collapsed = false
}

function handleMouseLeave() {
  if (state.value.open || state.value.passive) return
  state.value.hover = false
  state.value.collapsed = true
}

function handleClick(val) {
  if (state.value.passive) return

  state.value.open = val
}

function onSubmenuClickClose() {
  setTimeout(() => {
    document
      .querySelectorAll('.Nv0-ul > li')
      .forEach((i) => i.classList.remove('active'))
    closeMenu()
  }, 100)
}

function Nv0HandleClick({ currentTarget }, Nv0) {
  if (Nv0.href) {
    debounce(0, handleClick, 'sideTime')(false)
    window.location.href = Nv0.href
  }
  toggleActiveOnLis(currentTarget)
}

function toggleActiveOnLis(current) {
  document
    .querySelectorAll('.Nv0-ul > li')
    .forEach((i) => i.classList.remove('active'))
  if (current) current.classList.toggle('active')
}

onUnmounted(() => {
  state.value = {
    hover: false,
    open: false,
    passive: true,
  }
})

onMounted(() => {
  state.value.passive = false

  if (route.query.side_open) {
    handleMouseEnter()
  }
})

const emits = defineEmits(['click:botao-generico'])

provide('pathTo', pathTo)
provide('state', state)
</script>

<style lang="sass">
@import "css/responsivo.sass"

:root
  --Nv0-sidebar-width: 5rem
  --Nv0-sidebar-width-open: 28rem
  --Nv0-sidebar-transition: ease-out
  // cubic-bezier(.4,0,.2,1)
  --Nv0-sidebar-border: 1px solid rgba(var(--neutral-100),0.1)
  --Nv0-sidebar-z-index: 5010
  --Nv0-sidebar-overflow: visible
  --Nv1-sidebar-width: 21.25rem
  --Nv2-sidebar-width: 21.25rem
  --Nv3-sidebar-width: 19rem
  --Nv1-sidebar-z-index: 9019
  --Nv2-sidebar-z-index: 9018
  --Nv3-sidebar-z-index: 9017
  --z-index-deep: 900
  --sidebar-top: 0
  --sidebar-header-height: 124px

  @include d(md)
    --Nv0-sidebar-width: 0rem

  @include d(sm)
    --Nv0-sidebar-width-open: 100%


.body--light
  --logo-color: #000
  --sidebar-bg: rgb(var(--neutral-100))
  --Nv1-sidebar-bg: #efeff2
  --Nv2-sidebar-bg:  #e0e0e6
  --Nv3-sidebar-bg: #d3d4d9

// .body--dark
//   --logo-color: white
//   --sidebar-bg: rgb(var(--d-neutral-10))
//   --Nv1-sidebar-bg: rgb(var(--d-neutral-20))
//   --Nv2-sidebar-bg: rgb(var(--d-neutral-30))
//   --Nv3-sidebar-bg: rgb(var(--d-neutral-30))
//   --Nv0-sidebar-border:1px solid rgba(var(--white),0.05)

.OSidebar
  position: fixed
  height: 100vh
  left: 0
  top: var(--sidebar-top)
  width: var(--Nv0-sidebar-width)
  z-index: var(--Nv0-sidebar-z-index)
  background: var(--sidebar-bg)
  transition:.2s  var(--Nv0-sidebar-transition)
  border-right: var(--Nv0-sidebar-border)
  transition-property: width
  overflow: var(--Nv0-sidebar-overflow)
  display: flex
  flex-direction: column
  *
    white-space: nowrap
  .showHeader &
    --sidebar-top: 51px

  .sidebar-active &
    width: var(--Nv0-sidebar-width-open)
    --Nv0-sidebar-overflow: initial

  .sidebar-open &
    width: var(--Nv0-sidebar-width-open)

  @include d(md)
    .q-item
      .q-icon
        font-size: 1.5rem !important

      p.one-line
        font-size: .875rem
  .icon-container ion-icon
    --ionicon-stroke-width: 20px
    display: inline-block !important

// Header
.OSidebar-header
  // padding: 1.5rem .5rem 1.5rem
  // border-bottom: var(--Nv0-sidebar-border)
  height: var(--sidebar-header-height)

  @include d(md)
    display: flex
    align-items: center
    justify-content: space-between
    padding: .75rem .5rem

//itens
.Nv0-ul
  margin-top: 2rem
  flex-wrap: nowrap
  overflow-y: auto
  overflow-x: hidden
  --scrolbar-width: 4px

  &::-webkit-scrollbar-thumb
    background: #6e7983 !important

  &::-webkit-scrollbar-track
    background: transparent !important

  @include d(md)
    margin-top: 1rem
    padding-bottom: 1rem

.Nv0-li
  white-space: nowrap
  min-height: 56px !important

.Nv0-text
  opacity: 0
  transition: opacity .2s ease

.sidebar-active,
.sidebar-open
  .OSidebar
    .Nv0-text
      opacity: 1

// Fundo
.OSidebar-deep
  width: 100vw
  height: 100vh
  background: rgba(0,0,0,0.1)
  z-index: var(--z-index-deep)
  position: fixed
  cursor: pointer
  top: var(--sidebar-top)
  left: 0
  backdrop-filter: blur(10px)
  transition: .2s ease background .2s
</style>
